/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const headerButton = {
    color: 'stokkeGray.accessibleText',
    variant: 'unstyled',
    size: 'min',
    width: 16,
    height: 12,
    flex: '0 0 auto',
    display: 'flex'
}

const commonDesktopColumn = {
    flexDirection: 'column',
    paddingTop: 6,
    paddingBottom: 8,
    alignSelf: 'stretch',
    flexGrow: 1
}

export default {
    variants: {
        mobile: {
            backButton: {
                ...headerButton
            },
            title: {
                color: 'stokkeGray.accessibleText',
                textStyle: 'Regular Medium',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                flex: '0 1 auto'
            },
            closeButton: {
                ...headerButton
            }
        },
        desktop: {
            columns: {
                gap: 4
            },
            column1: {
                ...commonDesktopColumn,
                minWidth: '13.75rem',
                // this is for the invisible column name component from design
                marginTop: '1.125rem',
                marginLeft: 2
            },
            column2: {
                ...commonDesktopColumn,
                minWidth: '13.75rem',
                gap: 4
            },
            column3: {
                ...commonDesktopColumn,
                minWidth: '7.5rem',
                maxWidth: '13.125rem',
                gap: {lg: 0, xl: 1.5},
                // this is for the invisible column name component from design
                marginTop: {lg: 0, xl: 4.5}
            },
            column4: {
                ...commonDesktopColumn,
                flexDirection: {base: 'column', '2xl': 'row'},
                flexWrap: {base: 'nowrap', '2xl': 'wrap'},
                paddingBottom: 6,
                gap: 6,
                alignItems: {base: 'flex-end', '2xl': 'flex-start'},
                justifyContent: {'2xl': 'flex-end'}
            },
            columnTeaser: {
                ...commonDesktopColumn,
                flexDirection: 'row',
                flexWrap: 'wrap',
                paddingBottom: 6,
                gap: 4
            }
        }
    }
}
